import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "creationV2__body creationV2__body--details" }
const _hoisted_2 = { class: "creationV2__scroll-wrapper" }
const _hoisted_3 = { class: "creationV2__container" }
const _hoisted_4 = { class: "font-bold text-2xl xs:text-3xl lg:text-[3vw] lg:leading-tight text-creation-on-background" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "fixed inset-x-0 bottom-12 flex items-center gap-[calc(12px+0.4vw)] z-20 p-4 lg:p-8"
}
const _hoisted_8 = { class: "button__icon stroke-[1.5]" }
const _hoisted_9 = {
  key: 0,
  "xlink:href": "/assets/icons-v3.svg#share"
}
const _hoisted_10 = {
  key: 1,
  "xlink:href": "/assets/icons-v3.svg#link"
}
const _hoisted_11 = {
  key: 2,
  "xlink:href": "/assets/icons-v3.svg#check"
}
const _hoisted_12 = { class: "text-sm lg:text-[calc(16px+0.4vw)] text-creation-on-background/creation-high" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_Transition, {
          appear: "",
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOut"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.agentMessage), 1)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "custom-classes",
          "enter-active-class": "animate__fadeInUp",
          "leave-active-class": "animate__fadeOutDown"
        }, {
          default: _withCtx(() => [
            (_ctx.shouldShowCTA)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: _ctx.campaign.successLink,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.didOpenCTA && _ctx.didOpenCTA(...args))),
                    target: "_top",
                    class: "button button--creation"
                  }, _toDisplayString(_ctx.ctaLabel), 9, _hoisted_6)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_Transition, {
      name: "custom-classes",
      "enter-active-class": "animate__fadeIn",
      "leave-active-class": "animate__fadeOut"
    }, {
      default: _withCtx(() => [
        (_ctx.campaign.successShareEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "button button--circle-creation button--circle-creation-primary shrink-0",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                  (_ctx.isWebShareAPIsupported)
                    ? (_openBlock(), _createElementBlock("use", _hoisted_9))
                    : (_ctx.isCopyLinkSupported && !_ctx.linkCopied)
                      ? (_openBlock(), _createElementBlock("use", _hoisted_10))
                      : (_ctx.isCopyLinkSupported && _ctx.linkCopied)
                        ? (_openBlock(), _createElementBlock("use", _hoisted_11))
                        : _createCommentVNode("", true)
                ]))
              ]),
              _createElementVNode("p", _hoisted_12, [
                (!_ctx.linkCopied)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('survey.askFriendLabel')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('survey.copyLinkSuccessButtonLabel')), 1)
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}